// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4e748241","453":"258b012d","732":"2b0c75ff","952":"49e696be"}[chunkId] + ".chunk.js";
};